export const COURT_LIST_REQUEST = "COURT_LIST_REQUEST";
export const COURT_LIST_SUCESS = "COURT_LIST_SUCESS";
export const COURT_LIST_FAIL = "COURT_LIST_FAIL";
export const COURT_SCHEDULE_LIST = "COURT_SCHEDULE_LIST";

export const COURT_CHANGE_STATE_REQUEST = "COURT_CHANGE_STATE_REQUEST";
export const COURT_CHANGE_STATE_SUCESS = "COURT_CHANGE_STATE_SUCESS";
export const COURT_CHANGE_STATE_FAIL = "COURT_CHANGE_STATE_FAIL";
export const COURT_CHANGE_STATE_RESET = "COURT_CHANGE_STATE_RESET";
